import LzPagination from './pagination.vue';

LzPagination.install = function(Vue) {
  Vue.component(LzPagination.name, LzPagination);
};

export default LzPagination;
